"use client";

// French copy of components/widgetPlatformCarousel (FR-1). Platform pages
// exist only in English, so the tiles still link to the English spokes.

import React from "react";
import Link from "next/link";
import { IoIosArrowForward } from "@react-icons/all-files/io/IoIosArrowForward";
import { StyledSection } from "../widgetPlatformCarousel/widgetPlatformCarousel.styles";
import { EnTag } from "./langSwitch.comp";
import { IPlatformTile } from "../widgetPlatformCarousel/widgetPlatformCarousel.data";

interface IWidgetPlatformCarouselProps {
  slug: string;
  tiles: IPlatformTile[];
}

export const WidgetPlatformCarouselFr = ({
  slug,
  tiles,
}: IWidgetPlatformCarouselProps) => {
  if (tiles.length === 0) return null;
  // Render the tile list twice in the track so the keyframe can translate
  // by -50% and loop seamlessly without a visible reset.
  const renderTile = (p: IPlatformTile, idx: number) => (
    <Link
      key={`${p.slug}-${idx}`}
      href={`/widgets/${slug}/${p.slug}`}
      className="tile"
      aria-label={`Intégration avec ${p.name} (en anglais)`}
      hrefLang="en"
      title={p.name}
    >
      <svg
        className="icon"
        role="img"
        viewBox="0 0 24 24"
        width="44"
        height="44"
        fill={`#${p.iconHex}`}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <path d={p.iconPath} />
      </svg>
    </Link>
  );

  return (
    <StyledSection>
      <h2>
        Compatible avec tous les créateurs de sites, plateformes e-commerce et sites web
      </h2>
      <div className="marquee" aria-label="Plateformes compatibles">
        <div className="track">
          {tiles.map((p, i) => renderTile(p, i))}
          {tiles.map((p, i) => renderTile(p, i + tiles.length))}
        </div>
      </div>
      <div className="view-all">
        <Link href="/platforms" title="Voir toutes les plateformes compatibles" hrefLang="en">
          Voir toutes les plateformes compatibles <EnTag />
          <IoIosArrowForward className="icon" />
        </Link>
      </div>
    </StyledSection>
  );
};
